import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//分页查询任务列表
export function orderTaskPage(data) {
    return request({
        url: serviceName + `/order-task/page`,
        method: 'post',
        data: data
    })
}
//部门主管指派
export function orderTaskDispatch(data) {
    return request({
        url: serviceName + `/order-task/dispatch`,
        method: 'post',
        data: data
    })
}
//员工认领
export function orderTaskPickUp(data) {
    return request({
        url: serviceName + `/order-task/pickUp?taskId=${data}`,
        method: 'get',
    })
}
//工单完成
export function submitTask(data) {
    return request({
        url: serviceName + `/order-task/submit-task`,
        method: 'post',
        data
    })
}
//通过任务id查询提交任务记录
export function getistByTaskId(data) {
    return request({
        url: serviceName + `/submit-task-record/get-list-by-taskId?taskId=${data}`,
        method: 'get',
    })
}
//转单
export function orderTaskTransfer(data) {
    return request({
        url: serviceName + `/transfer/start-transfer`,
        method: 'post',
        data
    })
}